import React, { Component } from 'react';

import './OnboardCompletedStep.css';

class OnboardCompletedStep extends Component {
    render() {
        return (
            <div className="onboard-completed-component">
                <div className="onboard-text">
                    <h2 className="completed-header">You're all set.</h2>
                    <p className="completed-sub-header">You should be receiving an email from us confirming your submission.</p>

                    <p className="completed-sub-header">In the meantime, we'll be using your submitted data to:</p>
                    <ul className="completed-ul">
                        <li>
                            <i className="ion ion-ios-contact-outline"/>
                            Create a <a target="_blank" rel="noopener noreferrer" href="https://www.shopify.com/">Shopify</a> account for your merch.
                        </li>
                        <li>
                            <i className="ion ion-link"/>
                            Link that Shopify account to <a target="_blank" rel="noopener noreferrer" href="https://www.printful.com/">Printful</a>, our distributor.
                        </li>
                        <li>
                            <i className="ion ion-bag"/>
                            Set up a store for you to sell on <a target="_blank" rel="noopener noreferrer" href="https://velesgaming.com/">our site</a>.
                        </li>
                    </ul>

                    <p className="completed-sub-header">In the meantime, <a target="_blank" rel="noopener noreferrer" href="mailto:contact@klyxx.co">contact us</a> if you have any questions.</p>
                    <hr />
                </div>
            </div>
        );
    }
}

export default OnboardCompletedStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/OnboardCompletedStep/OnboardCompletedStep.js